// importing components
import HomeBox from "../components/HomeBox";

function Home(){
    return(
        <div className="home flex items-center justify-center my-10">
            <HomeBox />
        </div>
    );
}

export default Home;